const Grade = {

    // FIELDS
    "name": "Name",
    "description": "Description",
    "search": "Search",

    // PAGE HEADER
    "grade": "Grade",

    // ERROR
    "error_name": "Enter Name",
    "error_desc": "Enter Description",

    // TABLE HEADER
    "table_name": 'NAME',
    "table_description": "DESCRIPTION",

}

export default Grade;